import { Api } from '../../../../../utility/client';

export async function triggerVirtualBsAction(baseId: string, actionId: string) {
  return Api.post(`/telesitting/v1/vbase/${baseId}/actions/${actionId}`);
}
